// extracted by mini-css-extract-plugin
export default {"invitation-button":"InvitationLinkButton_invitation-button__OUAuP","logo":"InvitationLinkButton_logo__PCqF-"};